import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import "assets/css/components/LanguageSwitcher.scss";
import { ReactComponent as IconSelectArrow } from 'assets/images/icons/icon-select-arrow.svg';

type LanguageSwitcherProps = {
  currentLanguage: string,
  options: string[]
};

const LanguageSwitcher = ({ currentLanguage, options }: LanguageSwitcherProps): JSX.Element => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [value, setValue] = useState(currentLanguage);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setValue(e.target.value);
    navigate(`/${e.target.value}`, { replace: true })
  }

  return (
    <div className='language-switcher'>
      <label htmlFor='language' className='visually-hidden'>
        { t('select_label_language') }
      </label>
      <div className='language-switcher-select-wrapper'>
        <select name='language' id='language' value={ currentLanguage } onChange={ handleChange }>
          { options.map(option => (
            <option key={ option } value={ option }>{ option }</option>
          )) }
        </select>
        <IconSelectArrow />
      </div>
    </div>
  );
};

export default LanguageSwitcher;
